export default {
    'upLoad post': '?m=file&f=upload&t=json',
    'upLoadAnd post': '?m=file&f=upload&t=json&watermark=1',
    'getDic get': '?t=json&m=baseconfig&f=searchDictsByPageCode&pageCode=allDicts',
    'getAddr get': '?t=json&m=cityconfig&f=selectCodeList&status=1',
};
